import { SceneTaskType } from 'lavva.exalushome/build/js/Services/Scenes/Scenes';
import {
  IconBulb,
  IconFacadeBlind,
  IconRGBCircles,
  IconWindFan,
  IconWoodenBlind,
  IconWoodenGate,
} from '../../../../../assets/control-icons';
import { IconDevices, IconNotification, IconPower, IconTime } from '../../../../../assets/icons';
import { IconLock } from '../../../../../assets/scenario-icons';
import { ActionTaskOption, ActionTaskVariantOption, TaskVariant } from '../../../../../types/actions';
import { ChannelType } from '../../../enums';

export const actionTaskVariants: ActionTaskVariantOption[] = [
  {
    title: 'action.create.tasks.variants.onOff',
    icon: <IconPower colorAccent />,
    variant: TaskVariant.OnOff,
    types: [ChannelType.Switch, ChannelType.Light],
  },
  {
    title: 'action.create.tasks.variants.dim',
    icon: <IconBulb isOn />,
    variant: TaskVariant.Dim,
    types: [ChannelType.Light],
  },
  {
    title: 'action.create.tasks.variants.setMicrowave',
    icon: <IconWindFan isOn={false} />,
    variant: TaskVariant.SetMicrowave,
    types: [ChannelType.Blind, ChannelType.Facade],
  },
  {
    title: 'action.create.tasks.variants.setRGBW',
    icon: <IconRGBCircles isOn={true} />,
    variant: TaskVariant.SetRGBW,
    types: [ChannelType.Light],
  },
  {
    title: 'action.create.tasks.variants.setBlind',
    icon: <IconWoodenBlind position={33} />,
    variant: TaskVariant.SetBlind,
    types: [ChannelType.Blind],
  },
  {
    title: 'action.create.tasks.variants.setFacade',
    icon: <IconFacadeBlind position={100} tilt={0} fullRange />,
    variant: TaskVariant.SetFacade,
    types: [ChannelType.Facade],
  },
  {
    title: 'action.create.tasks.variants.setGate',
    icon: <IconWoodenGate position={50} />,
    variant: TaskVariant.SetGate,
    types: [ChannelType.Gate],
  },
];

export const actionTasks: ActionTaskOption[] = [
  {
    title: 'action.create.tasks.list.stateChange',
    icon: <IconDevices />,
    type: SceneTaskType.DeviceTask,
  },
  {
    title: 'action.create.tasks.list.delay',
    icon: <IconTime />,
    type: SceneTaskType.DelayTask,
  },
  {
    title: 'action.create.tasks.list.lockExecution',
    icon: <IconLock />,
    type: SceneTaskType.LockExecution,
  },
  {
    title: 'action.create.tasks.list.notify',
    icon: <IconNotification />,
    type: SceneTaskType.NotifyTask,
  },
];
